import $ from 'jquery'

export default function scrollTo(pos, cb) {
	if (typeof pos == 'object' && pos.offset) {
		pos = pos.offset().top;
	}
	if (pos < 0) {
		pos = 0;
	}
	$('html, body').animate({ scrollTop: pos }, 400, cb);
}
